import cn from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import { Column, Row } from '../../../../../components/Basic/Blocks';
import { CheckButton } from '../../../../../components/Basic/Buttons';
import { LinkBlue } from '../../../../../components/Basic/Elements';
import { TableCell, TableLine } from '../../../../../components/Basic/Table';
import { TextGrey } from '../../../../../components/Basic/WrapsStyle';
import { TO_REALIZATION } from '../../../../../constans';
import { getDate, numberWithSpaces } from '../../../../../utils';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';
import ProviderList from '../../../../../components/Common/Input/ProviderList';

const REPORT_STATUS = {
  sold: 'Продажа',
  return: 'Возврат',
};

const REPORT_STATUS_1c = {
  confirmed: 'Проведена',
  not_confirmed: 'Не проведена',
  processed: 'Обработана',
  double: 'Дубль операции',
};

const ReportLine = ({
  MODES,
  FILTER,
  tab,
  shipmentMode = true,
  packagingMode = false,
  report = {},
  shipment = {},
  map = {},
  postingsPrint = {},
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  setOpenChzn = () => { },
  isMany = false,
  isDisabledPrint = () => { },
  providerMap = {},
  confrimedByReportsItem = {},
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const [info, setInfo] = useState(false);
  const dispatch = useDispatch();


  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const is_disabled_print = isDisabledPrint(report);

  let imgs = map[report.offer_id]?.images || [];

  return (
    <>
      <TableLine
        style={
          confrimedByReportsItem.price !== report.price && confrimedByReportsItem.price > 0
            ? { background: 'rgb(186 91 103 / 28%)' }
            : {}
        }
      >
        {report.is_printed && <div className={styles.status_line} />}
        {shipmentMode === MODES[0] && (
          <TableCell width={WIDTH_POSTING[9]} minWidth={WIDTH_POSTING[9]}>
            <CheckButton
              checked={report.info_1c?.status === 'confirmed'}
              onSelect={() => { }}
              small={true}
              disabled={report.info_1c?.status === 'double'}
            />
          </TableCell>
        )}
        <TableCell width={WIDTH_POSTING[0]}>
          <Column>
            <Row style={{ maxWidth: '123px', wordBreak: 'break-all' }}>
              {report.market === 'wb' ? report.posting?.posting_number : report.posting_number}{' '}
              {report.posting?.realization_by_report_id && (
                <>
                  <LinkBlue
                    to={TO_REALIZATION(report.posting?.realization_by_report_id)}
                    target={'_blank'}
                    style={{ fontSize: '14px' }}
                  >
                    {` -> ${report.posting?.realization_by_report_id}`}
                  </LinkBlue>
                </>
              )}
            </Row>

            <Row>
              {report.market === 'wb' && (
                <>
                  <TextGrey style={{ fontSize: '13px', color: '#6c11c9' }}>{report.shop}</TextGrey>
                </>
              )}
              {report.market === 'yandex' && (
                <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{report.shop}</TextGrey>
              )}
              {report.market === 'ozon' && (
                <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{report.shop}</TextGrey>
              )}
              {report.market === 'megamarket' && (
                <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{report.shop}</TextGrey>
              )}
              <TextGrey style={{ fontSize: '13px' }}>{` (${report.sale_schema}: ${report.skladName})`} </TextGrey>
            </Row>
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[1]}>
          <Column>
            <Column>
              <div className={styles.div_line_images}>
                <div className={styles.wrapper}>
                  <img
                    onClick={() => openImageViewer(imgs)}
                    className={styles.preview}
                    src={imgs.length > 0 ? imgs[0] : undefined}
                  />
                </div>
                <Column>
                  <div className={styles.name}>
                    {`${report.quantity} x ${report.name}  `}
                    <div className={cn(styles.offer_id)}>{report.offer_id}</div>
                  </div>
                </Column>
              </div>
            </Column>
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[1]}>{providerMap[report.provider_sku]?.name}</TableCell>
        <TableCell width={WIDTH_POSTING[4]} center={true}>
          {report.provider_sku}
        </TableCell>
        <TableCell width={WIDTH_POSTING[6]}>
          <div className={styles.num}> {report.common_quantity || 0}</div>
        </TableCell>

        <TableCell width={WIDTH_POSTING[4]} center={true}>
          <div className={styles.price}>
            {report.status === 'sold' && '+ '}
            {report.status === 'return' && '- '}

            {report.price_commissar ? (
              <>
                {numberWithSpaces(report.price_commissar || 0)}{' '}
                <span style={{ textDecoration: 'line-through', fontSize: '14px', }}>
                  {numberWithSpaces(report.price || 0)}
                </span>
              </>
            ) : (
              <>{numberWithSpaces(report.price || 0)}</>
            )}
          </div>
        </TableCell>

        <TableCell width={WIDTH_POSTING[4]} center={true}>
          <div
            className={cn(
              styles.status,
              report.status === 'Ожидает отгрузки' && styles.process,
              report.status === 'Не принят на CЦ' && styles.waiting,
              report.status === 'Идёт приёмка' && styles.waiting,
              report.status === 'Доставляется' && styles.sorted,
              report.status === 'Прибыл на ПВЗ' && styles.pickup,
              report.status === 'sold' && styles.sold,
              report.status === 'Доставлено' && styles.sold,
              report.status === 'Отменено' && styles.canceled,
              report.status === 'Отменено клиентом' && styles.controversial,
              report.status === 'Арбитраж' && styles.controversial,
              report.status === 'return' && styles.waiting,
              report.cancellation?.is_return && styles.return,
            )}
          >
            {REPORT_STATUS[report.status]}
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} minWidth={WIDTH_POSTING[4]} center={true}>
          <div
            className={cn(
              styles.status,
              report.info_1c?.status === 'confirmed' && styles.pickup,
              report.info_1c?.status === 'processed' && styles.canceled_by_client,
              report.info_1c?.status === 'not_confirmed' && styles.waiting,
              report.info_1c?.status === 'double' && styles.canceled,
            )}
          >
            {REPORT_STATUS_1c[report.info_1c?.status]}
          </div>
        </TableCell>

        <TableCell width={WIDTH_POSTING[12]}>
          <ProviderList selectProviderId={report.provider_id} disabled={true} />
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} center={true}>
          {report.sold_pair_info?.report_id && report.report_id !== report.sold_pair_info?.report_id && (
            <Column center={true}>
              <Row center={true}> + {numberWithSpaces(report.sold_pair_info?.sum)} </Row>
              <Row center={true}> {getDate(report.sold_pair_info?.date)}</Row>
            </Column>
          )}
        </TableCell>
        <TableCell width={WIDTH_POSTING[12]} center>
          {report.facktura?.date && getDate(report.facktura?.date)}
        </TableCell>

        {tab === 2 && (
          <TableCell width={WIDTH_POSTING[4]} center={true}>
            <Column>
              {report.facktura?.number}
              <TextGrey fontSize={'12px'}> {report.facktura?.name}</TextGrey>
            </Column>
          </TableCell>
        )}
        <TableCell width={WIDTH_POSTING[4]} center={true}>
          <div className={styles.price}>
            {report.status === 'sold' && '+ '}
            {report.status === 'return' && '- '}
            {numberWithSpaces(confrimedByReportsItem.price || 0)} /{' '}
            {numberWithSpaces(confrimedByReportsItem.quantity || 0)}
          </div>
        </TableCell>

        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
    </>
  );
};

export default ReportLine;
